import styled from "styled-components";


export const FooterContainer = styled.footer`
    border-top: 1px solid #a1acb2;
    background: #f3f2f1;
    color: #454a4c;
    font-family: "nta",Arial,sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-weight: 400;
    
        font-size: 16px;
    line-height: 1.25;
 
    padding-top: 40px;
    padding-bottom: 40px;
    
    ul {
        font-family: "nta", Arial, sans-serif;
        font-weight: 400;
        text-transform: none;
        display: inline-block;
        list-style: none;
        
        li {
            display: inline-block;
            margin: 0 15px 0 0;
            
            a {
                  color: #454a4c;
                  
                  &:link {
                   color: #454a4c;
                  }
                  
                  &:focus {
                        color: #0b0c0c;
                    }
                    
                  &:hover {
                        color: #171819;
                  }
                  &:visited {
                    color: #4c2c92;
                    }
            }
        }
    }
`


export const InnerWrappper= styled.div`
   width: 100%;
   
   @media (min-width: 1200px) {
       width: 66.6666%;
   }
`